import { axiosInstance, axiosJsonInstance } from "@/axios.instance";
import { AxiosResponse } from "axios";
import { ShareWithUsers, Types, InsightSharesData } from "@/store/reports/types";

export interface CustomReportEnabledResponse {
    customReportingEnabled: boolean;
	error: string;
}
export interface CustomScriptVaildResponse {
    customScriptValid: boolean;
	error: string;
}
export interface CustomReportResponse {
	successful: boolean;
	customReport: Types | null;
	error: string;
}

export interface ShareCustomReportResponse {
	successful: boolean;
	error: string;
}

export interface ShareDataCustomReportResponse {
	successful: boolean;
	shareCustomReportRequest: InsightSharesData
	error: string;
}

class ImmixCloudV2ApiHttpCCure {
	private axios: any;
	private axiosJson: any;

	constructor() {
		this.axios = axiosInstance;
		this.axiosJson = axiosJsonInstance;
	}

	public async customReportsEnabled(): Promise<AxiosResponse<CustomReportEnabledResponse>> {
		return await this.axios.get(`/CustomReports/CustomReportingEnabled`);
	}

	public async customScriptValid(sqlScript: string): Promise<AxiosResponse<CustomScriptVaildResponse>> {
		return await this.axiosJson.post(`/CustomReports/CustomScriptValid`, { sqlScript: sqlScript });
	}

	public async createCustomReport(customReport: Types): Promise<AxiosResponse<CustomReportResponse>>{
		return await this.axiosJson.post("/CustomReports/CreateCustomReport", customReport);
	}

	public async updateCustomReport(customReport: Types): Promise<AxiosResponse<CustomReportResponse>>{
		return await this.axiosJson.put("/CustomReports/UpdateCustomReport", customReport);
	}

	public async deleteCustomReport(insightID: number): Promise<AxiosResponse<CustomReportResponse>>{
		return await this.axiosJson.delete("/CustomReports/DeleteCustomReport/" + insightID);
	}

	public async getAvailableUsersAndGroups(searchTerm: string): Promise<AxiosResponse<ShareWithUsers[]>>{
		const response = await this.axios.get("/ShareReports/Search", {
			params: {
				searchTerm
			}
		});
		return response;
	}

	public async shareCustomReport(shareData: InsightSharesData): Promise<AxiosResponse<ShareCustomReportResponse>>{
		return await this.axiosJson.put("/ShareReports/ShareCustomReport", shareData);
	}

	public async getSharesForCustomReport(insightID: number): Promise<AxiosResponse<ShareDataCustomReportResponse>>{
		return await this.axiosJson.get("/ShareReports/GetSharesForCustomReport/" + insightID);
	}

	public async removeAllSharesCustomReport(insightID: number): Promise<AxiosResponse<ShareCustomReportResponse>>{
		return await this.axiosJson.delete("/ShareReports/RemoveSharesCustomReport/" + insightID);
	}
}

const customReportsapi = new ImmixCloudV2ApiHttpCCure();
export default customReportsapi;
